<template>
    <div class="form-container">
        <h2>{{ isEditing ? 'Edit' : 'Add' }} Reason for Visit</h2>
        <hr />

        <div v-if="loading" class="text-center my-4">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>

        <div v-else>
            <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

            <form @submit.prevent="handleSubmit">
                <div class="mb-3">
                    <label class="form-label">Reason Title</label>
                    <input v-model="form.title" type="text" class="form-control" />
                    <div v-if="errors.title" class="text-danger">{{ errors.title[0] }}</div>
                </div>

                <div class="mb-3">
                    <label class="form-label">Description</label>
                    <textarea v-model="form.description" class="form-control" rows="3"></textarea>
                    <div v-if="errors.description" class="text-danger">{{ errors.description[0] }}</div>
                </div>

                <h5>Treatment Plans</h5>
                <div class="border rounded p-3 mb-3" v-for="(treatment, index) in form.treatments" :key="index">
                    <div class="mb-2">
                        <label>Title</label>
                        <input v-model="treatment.title" type="text" class="form-control" />
                        <div v-if="errors[`treatments.${index}.title`]" class="text-danger">
                            {{ errors[`treatments.${index}.title`][0] }}
                        </div>
                    </div>

                    <div class="mb-2">
                        <label>Description</label>
                        <input v-model="treatment.description" type="text" class="form-control" />
                        <div v-if="errors[`treatments.${index}.description`]" class="text-danger">
                            {{ errors[`treatments.${index}.description`][0] }}
                        </div>
                    </div>

                    <button type="button" class="btn btn-sm btn-danger mt-2" @click="removeTreatment(index)"
                        v-if="form.treatments.length > 1">
                        ❌ Remove
                    </button>
                </div>

                <button type="button" class="btn btn-sm btn-secondary mb-3" @click="addTreatment">
                    ➕ Add Treatment
                </button>

                <div class="d-flex gap-2 mt-4">
                    <button type="submit" class="btn btn-sm btn-primary" :disabled="submitting">
                        💾 {{ isEditing ? 'Update' : 'Save' }}
                    </button>
                    <button type="button" class="btn btn-sm btn-secondary"
                        @click="$router.push({ name: 'reason-list' })">
                        🔙 Cancel
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReasonForm',
    data() {
        return {
            form: {
                title: '',
                description: '',
                treatments: [{ title: '', description: '' }],
            },
            errors: {},
            errorMessage: '',
            loading: false,
            submitting: false,
        }
    },
    computed: {
        isEditing() {
            return !!this.$route.params.id;
        },
    },
    methods: {
        async loadReason() {
            this.loading = true;
            try {
                const res = await this.$api.get(`/reasons`);
                const reason = res.data.find((r) => r.id == this.$route.params.id);
                if (!reason) {
                    this.errorMessage = 'Reason not found';
                } else {
                    this.form.title = reason.title;
                    this.form.description = reason.description;
                    this.form.treatments = reason.treatment_plans.length
                        ? reason.treatment_plans.map((t) => ({
                            title: t.title,
                            description: t.description,
                        }))
                        : [{ title: '', description: '' }];
                }
            } catch (err) {
                this.errorMessage = err.response?.data?.message || 'Failed to load reason.';
            } finally {
                this.loading = false;
            }
        },
        async handleSubmit() {
            this.submitting = true;
            this.errors = {};
            this.errorMessage = '';

            try {
                if (this.isEditing) {
                    await this.$api.put(`/reasons/${this.$route.params.id}`, this.form);
                } else {
                    await this.$api.post(`/reasons`, this.form);
                }
                this.$router.push({ name: 'reason-list' });
            } catch (err) {
                if (err.response?.status === 422) {
                    this.errors = err.response.data.errors || {};
                } else {
                    this.errorMessage = err.response?.data?.message || 'Something went wrong.';
                }
            } finally {
                this.submitting = false;
            }
        },
        addTreatment() {
            this.form.treatments.push({ title: '', description: '' });
        },
        removeTreatment(index) {
            this.form.treatments.splice(index, 1);
        },
    },
    mounted() {
        if (this.isEditing) {
            this.loadReason();
        }
    },
}
</script>